import { configureStore } from "@reduxjs/toolkit";
import {rootReducer} from "./rootReducer";

export const rdxStore = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false}),
    devTools: process.env.NODE_ENV !== 'production'
  })
